export default __webpack_public_path__ + "cfffe4c371f5e11d372b398a87c51dd0.png";